import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Chats from "./Chats";
import { useQuery } from "react-query";
import { UserListApi } from "../../../Api";
import { AxiosResponse } from "axios";
import BarLoader from "react-spinners/BarLoader";
import { IoSearch } from "react-icons/io5";
import NumberList from "./NumberList";
import { IoMdArrowRoundBack } from "react-icons/io";

interface UserTypes {
  name: string;
  email: string;
  id: number;
}

export default function SMSConversionReport_V2() {
  const [selectedNumber, setSelectedNumber] = useState("");
  const [selectedAgent, setSelectedAgent] = useState<number | null>(null);
  const { state } = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [users, setUsers] = useState<UserTypes[]>();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const { refetch } = useQuery({
    queryKey: ["User_List", { campaign_id: state?.id }],
    queryFn: UserListApi,
    onSuccess: (resp: AxiosResponse) => {
      setIsLoading(false);
      setUsers(resp.data?.users || []);
      setSelectedAgent(resp.data?.users ? resp.data?.users[0]?.id : null);
    },
    enabled: false,
  });

  useEffect(() => {
    refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setSelectedNumber("");
  }, [selectedAgent]);

  useEffect(() => {
    const resize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", resize);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  const Numbers = (
    <div className="d-flex gap-2 flex-column h-100 overflow-x-auto py-3 pt-0 Numbers_List">
      <div className="pt-3 px-3 d-flex justify-content-between slign-items-center">
        <h4 className="mb-0">Pin Numbers</h4>
      </div>

      <div className="w-100 position-sticky z-2 top-0 chat-box-bg">
        <div className="input-group  p-2 w-100 chat-box-bg">
          <div className="input-group-prepend">
            <span className="input-group-text bg-white">
              <IoSearch />
            </span>
          </div>
          <input
            type="search"
            className="form-control"
            placeholder="Search Numbers"
            onChange={(e) => setSearch(e.target.value)}
            value={search}
          />
        </div>
      </div>

      <React.Fragment>
        <NumberList
          search={search}
          handleClick={(number) => setSelectedNumber(number)}
          openChat={selectedNumber}
          CampaignID={state?.id}
          AgentID={selectedAgent!}
        />
      </React.Fragment>
    </div>
  );
  return (
    <React.Fragment>
      <div className="content-wrapper m-0 position-relative">
        <section className="content position-absolute h-100 w-100 px-0">
          <div className="container-fluid vh-100 pt-3 pb-2">
            <div className="card h-100">
              <div className="card-header bg-white p-3 d-flex flex-wrap justify-content-between align-items-center">
                <h2 className="h5 mb-0 flex-grow-1">SMS Conversion Report</h2>

                <button
                  onClick={() => navigate(-1)}
                  className="btn btn-info text-white d-flex align-items-center fw-semibold"
                >
                  <IoMdArrowRoundBack /> Back
                </button>
              </div>
              <div className="w-100 d-flex gap-2 card-header bg-white p-2 m-0 flex-wrap">
                {users?.map((item, i) => (
                  <div
                    key={i}
                    className="p-2 rounded px-4 cursor-pointer"
                    style={{
                      backgroundColor:
                        selectedAgent === item?.id ? "#3d9970" : "#eef1f6",
                    }}
                    onClick={() => setSelectedAgent(item?.id)}
                  >
                    <p
                      className={`mb-0 fw-bold fs-14 ${
                        selectedAgent === item?.id ? "text-white" : ""
                      }`}
                    >
                      {item?.name}
                    </p>
                  </div>
                ))}
              </div>
              <div className="card-body chat-box-bg p-0">
                <div
                  className={`container-fluid overflow-hidden h-100 w-100 ${
                    !isLoading ? "d-none" : ""
                  }`}
                >
                  <div className="d-flex justify-content-center align-items-center w-100 h-100">
                    <div>
                      <h5 className="text-center text-secondary fs-sm">
                        Initializing
                      </h5>
                      <BarLoader
                        className="rounded-5"
                        height={6}
                        color="rgba(61, 153, 112, 0.5)"
                        width={250}
                      />
                    </div>
                  </div>
                </div>
                <div
                  className={`container-fluid overflow-hidden h-100 w-100 ${
                    isLoading ? "d-none" : ""
                  }`}
                >
                  {isMobile ? (
                    <div className="row h-100">
                      <div className="col-12 h-100 w-100 p-0 m-0">
                        <div className="d-block d-lg-none h-100 px-0">
                          {selectedNumber ? (
                            <div className="p-0 h-100">
                              <Chats
                                CampaignID={state?.id}
                                selectedAgent={selectedAgent}
                                SelectedNumber={selectedNumber}
                              />
                            </div>
                          ) : (
                            <div className="p-0 h-100">{Numbers}</div>
                          )}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className="row h-100">
                      <div className="col-6 col-lg-3 h-100 px-0 d-none d-lg-block border-right border-black">
                        {Numbers}
                      </div>
                      <div className="col-6 col-lg-9 h-100 px-0 d-none d-lg-block">
                        <Chats
                          CampaignID={state?.id}
                          selectedAgent={selectedAgent}
                          SelectedNumber={selectedNumber}
                        />
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </React.Fragment>
  );
}
